import { careConsentFormError } from '../common/constants/messages'

export type ContentAttributes = {
  bypassAssessmentSummary?: boolean
  bypassReview?: boolean
  customActivityIntroduction?: string
  customErrorMessage?: { defaultMessage: string; description: string }
  enableBackNavigation?: boolean
  group?: string
  hideInClientActivities?: boolean
  hideInstructionsIfHasPrereq?: boolean
  hideProgressBar?: boolean
  initialPageIfHasPrereq?: number
  linkedAssignmentTitle?: string
  linkedStatusAssignments?: (string | string[])[]
  linkedVideo?: string
  shownParentActivity?: string | string[]
  singlePageContent?: boolean
}

export const customContentAttributes: {
  [key: string]: ContentAttributes
} = {
  audCareConsent: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    customActivityIntroduction: 'CareOnboardingHeader',
    customErrorMessage: careConsentFormError,
    hideInClientActivities: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideProgressBar: true,
    linkedStatusAssignments: ['audCareConsent', 'audClientIntake', 'audInitialAssessmentMetadata'],
    singlePageContent: true,
    shownParentActivity: 'audClientIntake',
  },
  audClientIntake: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['audCareConsent', 'audClientIntake', 'audInitialAssessmentMetadata'],
  },
  audInitialAssessmentMetadata: {
    bypassAssessmentSummary: false,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideInClientActivities: true,
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['audCareConsent', 'audClientIntake', 'audInitialAssessmentMetadata'],
    linkedVideo: 'baseYourTherapyWithLyra',
    shownParentActivity: 'audClientIntake',
  },
  audSudExpansionCareConsent: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    customActivityIntroduction: 'CareOnboardingHeader',
    customErrorMessage: careConsentFormError,
    hideInClientActivities: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideProgressBar: true,
    linkedStatusAssignments: [
      'audSudExpansionCareConsent',
      'audSudExpansionClientIntake',
      'audSudExpansionInitialAssessmentMetadata',
    ],
    singlePageContent: true,
    shownParentActivity: 'audSudExpansionClientIntake',
  },
  audSudExpansionClientIntake: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: [
      'audSudExpansionCareConsent',
      'audSudExpansionClientIntake',
      'audSudExpansionInitialAssessmentMetadata',
    ],
  },
  audSudExpansionInitialAssessmentMetadata: {
    bypassAssessmentSummary: false,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideInClientActivities: true,
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: [
      'audSudExpansionCareConsent',
      'audSudExpansionClientIntake',
      'audSudExpansionInitialAssessmentMetadata',
    ],
    linkedVideo: 'baseYourTherapyWithLyra',
    shownParentActivity: 'audSudExpansionClientIntake',
  },
  baseYourCoachingWithLyra: {
    group: 'lessonPreviewMaximized',
  },
  baseYourTherapyWithLyra: {
    group: 'lessonPreviewMaximized',
  },
  bccCareConsent: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    customActivityIntroduction: 'CareOnboardingHeader',
    customErrorMessage: careConsentFormError,
    hideInClientActivities: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideProgressBar: true,
    linkedStatusAssignments: ['bccCareConsent', 'bccClientIntake', 'bccBaselineMetadata'],
    singlePageContent: true,
    shownParentActivity: 'bccClientIntake',
  },
  bccClientIntake: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['bccCareConsent', 'bccClientIntake', 'bccBaselineMetadata'],
  },
  bccBaselineMetadata: {
    bypassAssessmentSummary: false,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideInClientActivities: true,
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['bccCareConsent', 'bccClientIntake', 'bccBaselineMetadata'],
    linkedVideo: 'baseYourCoachingWithLyra',
    shownParentActivity: 'bccClientIntake',
  },
  bcmCareConsent: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    customActivityIntroduction: 'CareOnboardingHeader',
    customErrorMessage: careConsentFormError,
    hideInClientActivities: true,
    linkedAssignmentTitle: 'Client Intake',
    hideProgressBar: true,
    linkedStatusAssignments: ['bcmCareConsent', 'bcmClientIntake', 'baseBaselineExtendedMetadata'],
    singlePageContent: true,
    shownParentActivity: 'bcmClientIntake',
  },
  bcmClientIntake: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    linkedAssignmentTitle: 'Client Intake',
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['bcmCareConsent', 'bcmClientIntake', 'baseBaselineExtendedMetadata'],
  },
  baseBaselineExtendedMetadata: {
    bypassAssessmentSummary: false,
    bypassReview: true,
    linkedAssignmentTitle: 'Client Intake',
    hideInClientActivities: true,
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['bcmCareConsent', 'bcmClientIntake', 'baseBaselineExtendedMetadata'],
    shownParentActivity: 'bcmClientIntake',
  },
  bctCareConsent: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    customActivityIntroduction: 'CareOnboardingHeader',
    customErrorMessage: careConsentFormError,
    hideInClientActivities: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideProgressBar: true,
    linkedStatusAssignments: ['bctCareConsent', 'bctClientIntake', 'baseInitialAssessmentMetadata'],
    singlePageContent: true,
    shownParentActivity: 'bctClientIntake',
  },
  bctClientIntake: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['bctCareConsent', 'bctClientIntake', 'baseInitialAssessmentMetadata'],
  },
  baseInitialAssessmentMetadata: {
    bypassAssessmentSummary: false,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideInClientActivities: true,
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['bctCareConsent', 'bctClientIntake', 'baseInitialAssessmentMetadata'],
    linkedVideo: 'baseYourTherapyWithLyra',
    shownParentActivity: 'bctClientIntake',
  },
  baseReleaseHealthRecord: {
    bypassReview: true,
    enableBackNavigation: true,
  },
  cleCareConsent: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    customActivityIntroduction: 'CareOnboardingHeader',
    customErrorMessage: careConsentFormError,
    hideInClientActivities: true,
    linkedAssignmentTitle: 'Client Intake',
    hideProgressBar: true,
    linkedStatusAssignments: ['cleCareConsent', 'cleClientIntake', 'cleInitialAssessment'],
    singlePageContent: true,
    shownParentActivity: 'cleClientIntake',
  },
  cleClientIntake: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    linkedAssignmentTitle: 'Client Intake',
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['cleCareConsent', 'cleClientIntake', 'cleInitialAssessment'],
  },
  cleInitialAssessment: {
    bypassAssessmentSummary: false,
    bypassReview: true,
    linkedAssignmentTitle: 'Client Intake',
    hideInClientActivities: true,
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['cleCareConsent', 'cleClientIntake', 'cleInitialAssessment'],
    linkedVideo: 'baseYourTherapyWithLyra',
    shownParentActivity: 'cleClientIntake',
  },
  daCareConsent: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    customActivityIntroduction: 'CareOnboardingHeader',
    customErrorMessage: careConsentFormError,
    hideInClientActivities: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideProgressBar: true,
    linkedStatusAssignments: [
      'daCareConsent',
      [
        'daAdolescentClientIntake',
        'daChildClientIntake',
        'daCouplesClientIntake',
        'daFamilyClientIntake',
        'daIndividualClientIntake',
      ],
      'daInitialAssessment',
    ],
    shownParentActivity: [
      'daAdolescentClientIntake',
      'daChildClientIntake',
      'daCouplesClientIntake',
      'daFamilyClientIntake',
      'daIndividualClientIntake',
    ],
    singlePageContent: true,
  },
  daAdolescentClientIntake: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['daCareConsent', 'daAdolescentClientIntake', 'daInitialAssessment'],
  },
  daChildClientIntake: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['daCareConsent', 'daChildClientIntake', 'daInitialAssessment'],
  },
  daCouplesClientIntake: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['daCareConsent', 'daCouplesClientIntake', 'daInitialAssessment'],
  },
  daFamilyClientIntake: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['daCareConsent', 'daFamilyClientIntake', 'daInitialAssessment'],
  },
  daIndividualClientIntake: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['daCareConsent', 'daIndividualClientIntake', 'daInitialAssessment'],
  },
  daInitialAssessment: {
    bypassAssessmentSummary: false,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideInClientActivities: true,
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: [
      'daCareConsent',
      [
        'daAdolescentClientIntake',
        'daChildClientIntake',
        'daCouplesClientIntake',
        'daFamilyClientIntake',
        'daIndividualClientIntake',
      ],
      'daInitialAssessment',
    ],
    shownParentActivity: [
      'daAdolescentClientIntake',
      'daChildClientIntake',
      'daCouplesClientIntake',
      'daFamilyClientIntake',
      'daIndividualClientIntake',
    ],
  },
  lcttCareConsent: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    customActivityIntroduction: 'CareOnboardingHeader',
    customErrorMessage: careConsentFormError,
    hideInClientActivities: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideProgressBar: true,
    linkedStatusAssignments: ['lcttCareConsent', 'lcttClientIntake', 'lcttInitialAssessment'],
    singlePageContent: true,
    shownParentActivity: 'lcttClientIntake',
  },
  lcttClientIntake: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['lcttCareConsent', 'lcttClientIntake', 'lcttInitialAssessment'],
  },
  lcttInitialAssessment: {
    bypassAssessmentSummary: false,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideInClientActivities: true,
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['lcttCareConsent', 'lcttClientIntake', 'lcttInitialAssessment'],
    linkedVideo: 'baseYourTherapyWithLyra',
    shownParentActivity: 'lcttClientIntake',
  },
  sscCareConsent: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    customActivityIntroduction: 'CareOnboardingHeader',
    customErrorMessage: careConsentFormError,
    hideInClientActivities: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideProgressBar: true,
    linkedStatusAssignments: ['sscCareConsent', 'sscClientIntake', 'sscBaselineMetadata'],
    singlePageContent: true,
    shownParentActivity: 'sscClientIntake',
  },
  sscClientIntake: {
    bypassAssessmentSummary: true,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['sscCareConsent', 'sscClientIntake', 'sscBaselineMetadata'],
  },
  sscBaselineMetadata: {
    bypassAssessmentSummary: false,
    bypassReview: true,
    linkedAssignmentTitle: 'Care Onboarding',
    hideInClientActivities: true,
    hideInstructionsIfHasPrereq: true,
    initialPageIfHasPrereq: 1,
    linkedStatusAssignments: ['sscCareConsent', 'sscClientIntake', 'sscBaselineMetadata'],
    linkedVideo: 'baseYourTherapyWithLyra',
    shownParentActivity: 'sscClientIntake',
  },
}
